import { useEffect, useRef, useState } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { downloadFile, getAxiosResponse, postAxiosResponse } from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import { currentDateWithFormat, dateFormat } from "../services/Util";
import Constants from "../Constants";
import { useSelector } from "react-redux";
import jQuery from'jquery';
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import $ from "jquery";

export default function Alerts() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const translate = t;
    const navigate = useNavigate();
    const location = useLocation();

    const state = location.state;

    const bootstrapData = useSelector(
        (reduxStore) => reduxStore.customer_bootstrap_data
    ).value;

    const [alerts, setAlerts] = useState([]);
    const [dates, setDates] = useState({});
    const [departments, setDepartments] = useState([]);
    const [allTags, setAllTags] = useState([]);
    const [tags, setTags] = useState([]);
    const [following, setFollowing] = useState([]);
    const [alertType, setAlertType] = useState([]);
    const [displayAlerts, setDisplayAlerts] = useState([]);
    const [disableHideAlerts, setDisableHideAlerts] = useState(true);
    const [groupBy, setGroupBy] = useState([]);
    const [groupByProject, setGroupByProject] = useState([]);
    const [viewBy, setViewBy] = useState({label: 'By due date', value: 'dueDate'});
    const [selectedDepartment, setSelectedDepartment] = useState({label: '', value: ''});
    const [selectedFollowing, setSelectedFollowing] = useState({label: 'All', value: 'false'});
    const [selectedAlertType, setSelectedAlertType] = useState({label: "All", value : Constants.BLANK});
    const [selectedTag, setSelectedTag] = useState([]);
    const [alertIdToHide, setAlertIdToHide] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if(state !== null) {
            setTimeout(()=>{
                setStartDate(state.startDate);
                setEndDate(state.endDate);
                setSelectedFollowing(state.onlyFollowed ? {label: 'Followed by me', value: 'true'} : {label: 'All', value: 'false'});
                setInitialized(true);
            },500);
        }
    }, [state])

    useEffect(() => {
        fetchDepartments();
        getAxiosResponse(APIUrls.TAGS)
        .then((res) => {
            if (res.data.code === 200) {
                const options = res.data.data.result.map(({ id, display }) => ({
                    label: display,
                    value: id,
                }));
                setTags(options);
                setAllTags(options);
            }
        });
        fetchFollowing();
        fetchAlertType();
        setDisplayAlerts([{
            label: translate("user_alert.view_byduedate"),
            value: Constants.DUE_DATE
        }, {
            label: translate("user_alert.view_byproject"),
            value: Constants.PROJECT
        }])
        updateAllCheckbox();
        $('.lastdisable').trigger('focus');
    }, []);

    useEffect(() => {
        setupGroups();
    }, [viewBy])

    useEffect(() => {
        if(initialized) {
            fetchUserAlerts();
        }
    }, [initialized, selectedDepartment, selectedFollowing, selectedAlertType, selectedTag]);

    const getFilters = () => {
        let filterUrl = '?';
        if (selectedDepartment.value !== Constants.BLANK)
            filterUrl += `deptId=${selectedDepartment.value}&`;
        if(selectedFollowing.value !== Constants.BLANK)
            filterUrl += `onlyFollowed=${selectedFollowing.value}&`;
        if(selectedAlertType.value !== Constants.BLANK)
            filterUrl += `filterType=${selectedAlertType.value}&`;
        if(selectedTag.length !== 0) {
            selectedTag.map((tag) => {
                filterUrl += `tag=${tag.label}&`
            })
        }
        if(startDate !== Constants.BLANK && startDate !== null)
            filterUrl += `startDate=${startDate}&`;
        if(endDate !== Constants.BLANK && endDate !== null)
            filterUrl += `endDate=${endDate}&`;

        return filterUrl;
    }

    const fetchUserAlerts = () => {
        getAxiosResponse(APIUrls.USER_ALERTS + getFilters())
        .then((res) => {
            setAlerts(res.data.data.resource);
            setDates(res.data.data.displayName[0]);
            let options = res.data.data.resource.map((userAlert) => ({
                key: userAlert.projectId,
                title: userAlert.projectName
            }))
            setGroupByProject(options.filter((elt, index) => index === options.findIndex( elem => elem.key === elt.key)));
            let groupByDueDate = [{to:0,title:translate("user_alert.group_overdue")},
            {from:0,to:2*24*3600,title:translate("user_alert.group_dueintwodays")},
            {from:2*24*3600,to:7*24*3600,title:translate("user_alert.group_dueinaweek")},
            {from:7*24*3600,title:translate("user_alert.group_dueafteraweek")}];
                
            groupByDueDate.map((group) => {
                    var alertsDisplay = group.alertsDisplay = [];
                    res.data.data.resource.map((userAlert) => {
                        var include = true;
                        var secondsToDueDate = userAlert.secondsToDueDate;
                        if (typeof(group.from) === Constants.NUMBER)
                            include = include && (secondsToDueDate > group.from);
                        if (typeof(group.to) === Constants.NUMBER)
                            include = include && (secondsToDueDate <= group.to);
                        if (include) {
                            alertsDisplay.push(userAlert);
                        } 
                    })
                })
            setGroupBy(viewBy.value === Constants.DUE_DATE ? groupByDueDate : groupByProject);
        });
    }

    const fetchDepartments = () => {
        getAxiosResponse(APIUrls.ALL_DEPARTMENT)
        .then((res) => {
          const options = [{label: translate("project_page.all"), value: Constants.BLANK}]
          res.data.data.map((department) => (
            options.push({
              label: department.name,
              value: department.id
            })
          ))
          setDepartments(options);
        })
    }

    const fetchFollowing = () => {
        setFollowing([{
            label: translate("project_page.all"),
            value: "false"
        }, {
            label: translate("user_alert.followed_by_me"),
            value: "true"
        }]);
    }

    const fetchAlertType = () => {
        let data = [];
        data.push({
            label: translate("project_page.all"),
            value: Constants.BLANK
        },
        {
            label: translate("user_alert.label_project_delivery_deadline"),
            value: Constants.PROJECT_DELIVERY_DEADLINE_WARNING
        },
        {
            label: translate("user_alert.label_project_bid_selection_deadline"),
            value: Constants.PROJECT_BID_SELECTION_DEADLINE_WARNING
        },
        {
            label: translate("user_alert.label_language_review_task_due"),
            value: Constants.LANGUAGE_REVIEW_TASK_DUE_WARNING
        }, 
        {
            label: translate("user_alert.label_close_project_pending"),
            value: Constants.CLOSE_PROJECT_PENDING_WARNING
        })
        if(bootstrapData?.features?.CUSTOM_TASK) {
            data.push({label: translate("user_alert.label_incomplete_task_due"), value: Constants.INCOMPLETE_TASK_DUE_WARNING})
        }
        setAlertType(data);
    }

    const updateAllCheckbox = () => {
        var allItemSelector = "input[type='checkbox'][class='group-item']";
        var checkedItemCount = jQuery(allItemSelector+":checked").length;
        var check = jQuery(allItemSelector).length == checkedItemCount;
        jQuery("#group-all").prop("checked", check);
        if (checkedItemCount > 0)
            setDisableHideAlerts(false);
        else
            setDisableHideAlerts(true);
    }

    const onGroupTitle = (e) => {
        var checkbox = jQuery(e.currentTarget);
        var title = checkbox.attr("data-title");
        var checked = checkbox.is(":checked")?true:false;
        var selector = "input[type='checkbox'][class='group-item'][data-title='"+title+"']";
        if (Constants.ALL_SELECTOR === title)
            selector = "input[type='checkbox'][class='group-item'],input[type='checkbox'][class='group-title']";
        jQuery(selector).prop("checked",checked);
        updateAllCheckbox();
    }

    const onGroupItem = (e) => {
        var checkbox = jQuery(e.currentTarget);
        var title = checkbox.attr("data-title");
        var selector = "input[type='checkbox'][class='group-item'][data-title='"+title+"']";
        var titleSelector = "input[type='checkbox'][class='group-title'][data-title='"+title+"']";
        var check = jQuery(selector).length === jQuery(selector+":checked").length;
        jQuery(titleSelector).prop("checked", check);
        updateAllCheckbox();
    }

    const onDismiss = (e) => {
        showModel();
        setAlertIdToHide([jQuery(e.currentTarget).attr("data-id")]);
    }
    $(".hidegb-alert.m-0").on("keydown", function (e) {
        if (e.key === Constants.ENTER) {
            $(this).addClass('focusAdd');
            onDismiss()
        }
      });
        const hideAlertsSave = (alertIdsToHide) => {
        let projectAlertIds = {projectAlertIds : alertIdsToHide}
        postAxiosResponse(APIUrls.DISMISS_USER_ALERTS, projectAlertIds)
        .then((res) => {
            if(res.data.data.success === true) {
                fetchUserAlerts();
                setAlertIdToHide([]);
            }
        })
    }

    const hideAlerts = () => {
        var groupItems = jQuery("input[type='checkbox'].group-item:checked");
        var projectAlertIds = [];
        for (var i=0;i<groupItems.length;i++) {
            var id = jQuery(groupItems[i]).attr("data-id");
            projectAlertIds.push(id);
        }
        if(alertIdToHide.length !== 0) {
            projectAlertIds.push(...alertIdToHide);
        }
        hideAlertsSave(projectAlertIds);
    }

    const handleHideAlerts = () => {
        hideAlerts();
        hideModel();
        var groupItems = jQuery("input[type='checkbox'].group-item:checked");
        for (var i=0;i<groupItems.length;i++) {
            jQuery(groupItems[i]).prop("checked", false);
            setDisableHideAlerts(true);
        }
    }

    const filterUserAlerts = (filterType, selectedFilterValue) => {
        if (filterType === Constants.USER_DEPARTMENT_FILTER)
            setSelectedDepartment(selectedFilterValue);
        if(filterType === Constants.ONLY_FOLLOWED)
            setSelectedFollowing(selectedFilterValue);
        if(filterType === Constants.FILTER_TYPE)
            setSelectedAlertType(selectedFilterValue);

    }

    const updateSelectedTag = (value) => {
        setSelectedTag(selectedTag => [...selectedTag, value]);
        let filteredTaglist = allTags.filter((tag) => tag.value !== value.value);
        setTags(filteredTaglist.filter((ftl) => !selectedTag.includes(ftl)));
    }

    const removeTag = (tag) => {
        setSelectedTag(selectedTag.filter((selected) => selected.value !== tag.value));
        setTags(tags => [...tags, tag]);

        const selectedElement = $(document.activeElement).closest(".multiselect-output");
		if ($(document.activeElement).is(':last-child') &&
			selectedElement.children().length > 1) {
			selectedElement.find('button:nth-last-child(2)').trigger('focus');
		} else if ($(document.activeElement).is(':last-child')) {
			$(document.activeElement).closest(".global-dropdown-block").find('input:first-of-type').trigger('focus');
		}
    }

    const removeTagonKeydown = (event, tags) => {
		if (event.key === Constants.ENTER) {
			removeTag(tags);
		}
	}
    
    const showModel = () => {
        document.body.classList.add("modal-open");
        setTimeout(() => {
            jQuery("#cancel").trigger("focus");
            jQuery("#cancel").on("keydown", function (e) {
              if (e.key === Constants.TAB) {
                if (e.shiftKey === true) {
                  e.preventDefault();
                  jQuery("#hide-alerts").trigger("focus");
                }
              }
            });
            jQuery(".inner-lightbox-panel").on("keydown", function (e) {
              if (e.key === Constants.ESCAPE) {
                hideModel();
                $('.focusAdd').trigger('focus');
                $('.hidegb-alert').removeClass('focusAdd');
              }
            });
          }, 500);
    };
    $(document).on("click",".hidegb-alert",function() {
        $(this).addClass('focusAdd');
     });
     $(document).on("click","#cancel",function() {
       $('.focusAdd').trigger('focus');
       $('.hidegb-alert').removeClass('focusAdd');
     });

    const keydownOnHideAlerts = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            jQuery("#cancel").trigger("focus");
          }
        }
    };

    const navigateBackToHome= () => {
        navigate("/dashboard");
    }

    const navigateBackToHomeOnKeyDown = (e) => {
        if(e.key === Constants.ENTER) {
            navigateBackToHome();
        }
    }

    const hideModel = () => {
        document.body.classList.remove("modal-open");
    };

    const setupGroups = () => {
        let groupByDueDate = [{to:0,title:translate("user_alert.group_overdue")},
        {from:0,to:2*24*3600,title:translate("user_alert.group_dueintwodays")},
        {from:2*24*3600,to:7*24*3600,title:translate("user_alert.group_dueinaweek")},
        {from:7*24*3600,title:translate("user_alert.group_dueafteraweek")}];
        groupByDueDate.map((group) => {
            var alertsDisplay = group.alertsDisplay = [];
            alerts.map((userAlert) => {
                var include = true;
                var secondsToDueDate = userAlert.secondsToDueDate;
                if (typeof(group.from) === Constants.NUMBER)
                    include = include && (secondsToDueDate > group.from);
                if (typeof(group.to) === Constants.NUMBER)
                    include = include && (secondsToDueDate <= group.to);
                if (include) {
                    alertsDisplay.push(userAlert);
                } 
            })
        })

        groupByProject.map((group) => {
            var alertsDisplay = group.alertsDisplay = [];
            alerts.map((userAlert) => {
                if(group.key === userAlert.projectId) {
                    alertsDisplay.push(userAlert)
                }
            })
        })

        setGroupBy(viewBy.value === Constants.DUE_DATE ? groupByDueDate : groupByProject);

    }

    const getRelativeTime = (dateType, alertId) => {
        return Object.keys(dates).map((key) => {
            if(key === alertId.toString()) {
                return Object.keys(dates[key]).map((value) => {
                    if(value === dateType) {
                        return dates[key][value].relativeToNow;
                    }
                })
            }
        })
    }

    const downloadReport = () => {
        getAxiosResponse(APIUrls.USER_ALERT_XLSX)
        let currentDate = currentDateWithFormat(Constants.DATE_COMPARE_FORMAT);
        downloadFile(
            APIUrls.USER_ALERT_XLSX + getFilters(),
            translate("user_alert.report_name_prefix") + currentDate + ".xlsx"
        );
    }
    const crumbs = [
       {label:'Alerts', url:''}
      ]

      useEffect(() => {
        $('.lastdisable').trigger('focus');
      }, []);

      $(".rdt_Table").attr("aria-label","Alerts Table"); 

    return (
        <div className="body bg-color">
          <div id="container" className="dashboard-wrapper">
            <Header ref={scrollRef} />
            <LeftNavbar />
            <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
              <div id="content" className="dashboard-wrap">
                <Breadcrumb crumbs={ crumbs } />
                <div className="user-management-page">
                  <div className="project-heading userprofile-heading">
                    <div className="back-arrow flex-center">
                        <button aria-label="Back to Home" onClick={() => navigateBackToHome()} onKeyDown={(e) => navigateBackToHomeOnKeyDown(e)}>
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="13"
                            viewBox="0 0 14 13"
                            fill="none"
                            >
                            <path
                                d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                                fill="#1D4ED8"
                            />
                            </svg>
                            
                        </button>
                        <span>{translate("back_to_home")}</span>
                    </div>
                    <h3>
                      {`${t("user_alert.alerts")}`}
                    </h3>
                    <span>{`${t("user_alert.help")}`}</span>
                  </div>
                  <div className="white-bg">
                    {
                    <>
                    <div className="flex flex-center justify-end">
                      <div className="flex two-col flex-align-center">
                        <label>{translate("user_alert.view")}</label>
                        <div className="filter-inline-list global-dropdown-block">
                            <Select className="global-dropdown-select width-auto" classNamePrefix='cw'
                            name="Display Alerts"
                            aria-label="Display Alerts"
                            placeholder="Display Alerts"
                            options={displayAlerts}
                            onChange={(value) => setViewBy(value)}
                            value={displayAlerts.filter(function (alert) {
                                return alert.value === viewBy.value;
                            })}
                            ></Select>
                        </div>
                        <button className="dashboard-btn hidegb-alert" disabled={disableHideAlerts} onClick={showModel} id='hide-btn-id'>{`${t("user_alert.hide_alerts")}`}</button>
                        <button className="blue-btn active" onClick={downloadReport}>{`${t("settings_user_management_download_report")}`}</button>
                      </div>
                    </div>
                    <div className="profile-editonly-block">
                    <div className="role-and-department">
                        <h5 className="heading-width-border">{translate("user_alert.general_filters")}</h5>
                        <div className="profile-edit-form">
                            <div className="flex wrap-dropdown">
                                <div className="global-dropdown-block flex-center">
                                    <label>{translate("user_alert.department")}</label>
                                    <Select className="global-dropdown-select" classNamePrefix='cw'
                                    name="Department"
                                    aria-label="Department"
                                    placeholder="Department"
                                    options={departments}
                                    onChange={(value) => filterUserAlerts(Constants.USER_DEPARTMENT_FILTER, value)}
                                    value={departments.filter(function (department) {
                                        return department.value === selectedDepartment.value;
                                    })}
                                    ></Select>
                                </div>
                                <div className="global-dropdown-block flex-center">
                                    <label>{translate("user_alert.following")}</label>
                                    <Select className="global-dropdown-select" classNamePrefix='cw'
                                    name="Following"
                                    aria-label="Following"
                                    placeholder="Following"
                                    options={following}
                                    onChange={(value) => filterUserAlerts(Constants.ONLY_FOLLOWED, value)}
                                    value={following.filter(function (follow) {
                                        return follow.value === selectedFollowing.value;
                                    })}
                                    ></Select>
                                </div>
                                <div className="global-dropdown-block flex-center">
                                    <label>{translate("user_alert.tags")}</label>
                                    <Select className="global-dropdown-select" classNamePrefix='cw'
                                    name="Tags"
                                    aria-label="Tags"
                                    placeholder="Tags"
                                    options={tags}
                                    value={{
                                        label: "Select or enter tag",
                                        value: Constants.BLANK,
                                    }}
                                    onChange={(value) => updateSelectedTag(value)}
                                    ></Select>
                                    <div className="multiselect-output flex">
                                        {selectedTag && selectedTag.map((tag) => {
                                            return <button aria-label={"Remove " + tag.label} onClick={() => removeTag(tag)}
                                            onKeyDown={(e) =>{if (e.key === Constants.ENTER) {removeTag(tag)}}}
                                            >
                                                <strong>{tag.label}</strong>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                                <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                </svg>
                                            </button>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className="profile-editonly-block">
                    <div className="role-and-department">
                        <h5 className="heading-width-border">{translate("user_alert.alert_filter")}</h5>
                        <div className="profile-edit-form">
                            <div className="flex wrap-dropdown">
                                <div className="global-dropdown-block flex-center">
                                    <label>{translate("user_alert.type")}</label>
                                    <Select className="global-dropdown-select" classNamePrefix='cw'
                                    name="Alert Type"
                                    aria-label="Type"
                                    placeholder="Alert Type"
                                    options={alertType}
                                    onChange={(value) => filterUserAlerts(Constants.FILTER_TYPE, value)}
                                    value={alertType.filter(function (type) {
                                        return type.value === selectedAlertType.value;
                                    })}
                                    ></Select>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    {alerts?.length > 0 ? <div className="table-responsive global-table ">
                        <table className="sortable" aria-label="Alerts">
                            <thead>
                                <tr>
                                    <th className="width-auto"><input role="checkbox" aria-label="Select All" type="checkbox" id="group-all" data-title=".*" className="group-title" onChange={(e) => onGroupTitle(e)}/></th>
                                    <th className="align-left width-auto">{translate("user_alert.alert")}</th>
                                    <th className="align-left width-auto">{translate("user_alert.project_name")}</th>
                                    <th className="align-left width-auto">{translate("user_alert.open_since")}</th>
                                    <th className="align-left width-auto">{translate("user_alert.due_date")}</th>
                                    <th className="align-left width-auto">{translate("user_alert.assigned_to")}</th>
                                    <th className="align-left width-auto">{translate("user_alert.action")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {groupBy && groupBy?.map((group) => {
                                        return (
                                            <>{group?.alertsDisplay?.length > 0 && <tr><td colSpan="7" className="align-left">{viewBy?.value === 'project' ? "Project : " + group.title : group.title}</td></tr>}
                                            {group?.alertsDisplay?.map((alert) => {
                                                    return (
                                                        <><tr>
                                                            <td><input role="checkbox" aria-label={"Select " + alert.display} type="checkbox" data-id={alert.id} data-title={group.title} className="group-item" onChange={(e) => onGroupItem(e)}/></td>
                                                            <td>
                                                                {alert?.actionUrl?.length > 0 ? <a className="m-0" href={"/project/"+alert.projectId}>{alert.display}</a> : alert.display}
                                                            </td>
                                                            <td>
                                                                <a className="m-0" href={"/project/"+alert.projectId}>{alert.projectName} ({alert.userGroupName})</a>
                                                            </td>
                                                            <td className="align-left">
                                                                
                                                                <div className="w-d100 relative">
                                                                    <span className="font-zero setFastpass">{alert.openSince !== Constants.BLANK ? dateFormat(alert.openSince, Constants.DATE_IN_WORDS) : Constants.BLANK}</span>
                                                                    <span aria-hidden="true">{alert.openSince !== Constants.BLANK ? dateFormat(alert.openSince, Constants.API_DATE_FORMAT) : Constants.BLANK}</span>
                                                                </div>
                                                                <div className="w-d100">{getRelativeTime("openSince", alert.id)}</div>
                                                            </td>
                                                            <td className="align-left">
                                                                <div className="w-d100 relative">
                                                                    <span className="font-zero setFastpass">{dateFormat(alert.dueDate, Constants.DATE_IN_WORDS)}</span>
                                                                    <span aria-hidden="true">{dateFormat(alert.dueDate, Constants.API_DATE_FORMAT)}</span>
                                                                </div>
                                                                <div className="w-d100">{getRelativeTime("dueDate", alert.id)}</div>
                                                            </td>
                                                            <td className="align-left">
                                                                {alert?.taskOwnerUrl?.length > 0 ? <a href={alert.taskOwnerUrl}>{alert.taskOwner}</a> : alert.taskOwner}
                                                            </td>
                                                            <td className="align-left">
                                                                <a className="m-0 hidegb-alert" data-id={alert.id} onClick={(e) => onDismiss(e)}
                                                                tabIndex={0}>
                                                                   {translate("user_alert.hide_alert")}
                                                                </a>
                                                                {alert.type === Constants.PROJECT_BID_SELECTION_DEADLINE_WARNING && <> | <a className="m-0" href="#project/\${projectId}/bids">Select Bid</a></>}
                                                                {(alert.type === Constants.PROJECT_DELIVERY_DEADLINE_WARNING || alert.type === Constants.CLOSE_PROJECT_PENDING_WARNING) && 
                                                                    <> | <a className="m-0" href={"/project/"+alert.projectId+"/messages/create"}>
                                                                        {alert.projectVendorType === Constants.INTERNAL ? translate("user_alert.message_internal_translator") : translate("user_alert.message_vendor")}
                                                                    </a></>
                                                                }
                                                                {(alert.type === Constants.INCOMPLETE_TASK_DUE_WARNING && alert.actionUrl.length > 0) && 
                                                                    <> | <a className="m-0" href={alert.actionUrl}>
                                                                        {alert.taskType.originalEnum === 'CUSTOM' && translate("user_alert.view_task")}
                                                                    </a></>
                                                                }
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }
                                            </>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div> : 
                    <div className="no-data-display align-center">
                        <i className="nodata-icon"></i>
                        <p>{Constants.NO_DATA_FOUND}</p>
                    </div> }
                    </>}
                  </div>
                </div>
              </div>
            </section>
          </div>
    
          <div className="lightbox-panel" aria-labelledby="alert-popup" aria-modal="true" role="dialog">
            <div className="inner-lightbox-panel pb-0">
              <div className="modal-header flex padd-lr" id='alert-popup'>
                <strong>{`${t("user_alert.hide_alerts")}`}</strong>
              </div>
              <div className="lightbox-content padd-22">
                <p className="f16-para">{translate("user_alert.hide_alerts_message")}</p>
              </div>
              <div className="modal-footer modal-footer-border flex px-22">
                <button id="cancel" className="btn btn-bold" onClick={hideModel}>
                  {`${t("button_cancel")}`}
                </button>
                <button id="hide-alerts" className="btn btn-bold active" onClick={handleHideAlerts} onKeyDown={keydownOnHideAlerts}>
                {`${t("user_alert.hide_alerts")}`}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
  
}
